import axios from "axios";
import { useAuthStore } from "../../stores/stores";
import { message } from "antd";
import { routesConfig } from "../routes";

export const BASE_URL = process.env.REACT_APP_BASE_API_URL_2;

export const axiosConfigV3 = axios.create({
  baseURL: BASE_URL,
  timeout: 55000,
  withCredentials: true,
  headers: {
    "content-type": "application/json",
  },
});

axiosConfigV3.interceptors.request.use(
  (config) => {
    const accessToken = useAuthStore.getState().accessToken;
    if (!config.headers["Authorization"] || accessToken) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);
const currentUrl = new URL(window.location.href);

axiosConfigV3.interceptors.response.use(
  async (response) => {
    if (currentUrl.pathname.replace(/^\//, "") === routesConfig.maintenance) {
      window.history.length > 2
        ? window.history.back()
        : (window.location.href = "/");
    }
    return response;
  },
  async (error) => {
    const prevRequest = error?.config;
    if (error?.response?.status === 403 && !prevRequest?.sent) {
      prevRequest.sent = true;
      try {
        const refreshToken = useAuthStore.getState().refreshToken;
        const accessToken = useAuthStore.getState().accessToken;
        if (refreshToken && accessToken) {
          prevRequest.headers["Authorization"] = `Bearer ${accessToken}`;
          return axiosConfigV3(prevRequest);
        }
      } catch (error) {
        location.replace("/login");
      }
    } else if (error?.response?.status === 400) {
      message.error(error.response.data.message);
    } else if (error?.response?.status === 401) {
      // unauthorize
      const logout = useAuthStore.getState().logout;
      logout();
      return Promise.reject(error);
    } else if (error?.response?.status === 503) {
      //server down
      const logout = useAuthStore.getState().logout;
      logout();
      return Promise.reject(error);
    } else if (error?.response?.status === 500) {
      message.error(
        error.response.data.message ||
          "Hệ thống bị gián đoạn vui lòng quay lại sau."
      );
    } else if (error?.response?.status === 502) {
      if (currentUrl.pathname !== "/" + routesConfig.maintenance) {
        currentUrl.pathname = "/maintenance";
        window.location.href = currentUrl.href;
      }
    }
    return Promise.reject(error);
  }
);
